<script setup lang="ts">
import { newsApi, sysApi } from "@/api/index";
import type { Protocol } from "@xianlaibang/shared/types";
import logoImg from "~/assets/scss/static/logo/logo.png";
import logoImgs from "~/assets/scss/static/logo/logos.png";

const { resources, setResources, getResourceImage } = useSystemResources();
const wechatGroupImage = computed(() => getResourceImage("wechat_group"));
const appQrCodeImage = computed(() => getResourceImage("app_qr_code"));
const wechatQrCodeImage = computed(
  () =>
    getResourceImage("wechat_qr_code") ||
    "https://xianmao-equity.oss-cn-guangzhou.aliyuncs.com/directGoods/1750c794-998c-4048-a442-5ea729adc647.png",
);

async function ensureSystemResources() {
  if (resources.value.length > 0) return;

  try {
    const resourceRes = await sysApi.getResources();
    setResources(resourceRes.data);
  } catch (error) {
    console.error("获取系统资源失败", error);
  }
}

const protocolList = ref<Protocol[]>();

onMounted(async () => {
  await ensureSystemResources();
  const protocolRes = await newsApi.getProtocol();
  protocolList.value = protocolRes.data;
});
</script>
<template>
  <ElContainer class="default-layout">
    <ElHeader class="site-header">
      <div class="site-header__inner">
        <NuxtLink to="/" class="site-header__logo">
          <img :src="logoImg" alt="闲来帮 Logo" />
        </NuxtLink>
        <AppNavbar />
      </div>
    </ElHeader>
    <ElMain>
      <slot />
    </ElMain>
    <AppFloatNav />
    <div class="about">
      <div class="area">
        <div class="contact">
          <NuxtLink to="/">
            <img :src="logoImgs" alt="logo" />
          </NuxtLink>
          <div class="item">电话：4001-886-030</div>
          <div class="item">周一至周五：09:00~18:30</div>
          <div class="item">联系邮箱：xmjishou@126.com</div>
        </div>
        <div class="vertical" />
        <div class="info">
          <div style="width: 40%">
            <div class="title">相关链接</div>
            <NuxtLink class="link" to="/recharge">关于我们</NuxtLink>
            <NuxtLink class="link" to="/news">平台资讯</NuxtLink>
            <NuxtLink class="link" to="/user/feedback">意见反馈</NuxtLink>
          </div>
          <div style="width: 60%">
            <div class="title">网站协议</div>
            <div
              class="agreement"
              style="
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
              "
            >
              <NuxtLink
                class="link line-2"
                v-for="item in protocolList"
                :to="`/notice/${item.platformProtocolId}`"
                >{{ item.protocolName }}</NuxtLink
              >
            </div>
          </div>
        </div>
        <div class="vertical" />
        <div class="info">
          <div class="qrcode">
            <img v-if="wechatGroupImage" :src="wechatGroupImage" alt="微信交流群" />
            <div>微信交流群</div>
          </div>
          <div class="qrcode">
            <img v-if="appQrCodeImage" :src="appQrCodeImage" alt="闲来帮 app" />
            <div>闲来帮app</div>
          </div>
          <div class="qrcode">
            <img :src="wechatQrCodeImage" alt="微信小程序" />
            <div>微信小程序</div>
          </div>
        </div>
      </div>
    </div>
    <FooterDefault />
  </ElContainer>
</template>
 
<style lang="scss" scoped>
.default-layout {
  position: relative;
  padding-top: 54px;

  .site-header {
    position: fixed;
    top: 0;
    z-index: 99;
    width: 100%;
    height: 54px;
    padding: 0;
    background-color: #fff;
    border-bottom: 1px solid #f1f2f5;
    box-shadow: 0 4px 18px rgba(15, 23, 42, 0.04);

    &__inner {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: min(1180px, calc(100% - 48px));
      max-width: 100%;
      height: 100%;
      margin: 0 auto;
      padding: 0;
      box-sizing: border-box;
      gap: 40px;
    }

    &__logo {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      text-decoration: none;

      img {
        height: 34px;
        width: auto;
        display: block;
      }
    }
  }

  .el-main {
    padding: 0;
    background-color: #fff;
  }

  .about {
    background-color: #0e2036;
    padding-bottom: 20px;
    color: #fff;

    .area {
      display: flex;
      justify-content: space-between;
      width: 1500px;
      margin: 0 auto;
      padding-top: 20px;
      box-sizing: border-box;

      .contact {
        text-align: left;
        width: 320px;

        img {
          height: 80px;
        }

        .item {
          height: 36px;
          line-height: 36px;
        }
      }

      .vertical {
        width: 1px;
        height: 180px;
        background: #4a5769;
        border-radius: 0px 0px 0px 0px;
        margin-top: 10px;
      }

      .info {
        display: flex;
        justify-content: space-between;
        text-align: center;
        font-size: 18px;
      }

      .title {
        color: #ff7a3c;
        font-size: 20px;
        padding: 10px 0px;
        font-weight: bold;
      }

      .link {
        display: block;
        color: #ffffff;
        text-decoration: none;
        padding: 6px 0;
        cursor: pointer;
        font-size: 14px;
        line-height: 1.5;
      }

      .line-2 {
        width: 50%;
        box-sizing: border-box;
      }

      .link:hover {
        color: #ff7a3c;
      }

      .qrcode {
        padding: 20px;
        text-align: center;

        img {
          width: 120px;
          border-radius: 8px;
        }
      }
    }
  }
}
</style>
